import axios from "axios";
import {
  GetBillsRequestBody,
  GetBillsRequestResponse,
  DownloadBillResponse,
  GetGraphDataBillsResponse,
  GetBillsIdDocumentsListRequestResponse,
  DownloadBillsListRequestResponse,
  GetBillingTypeRequestBody,
  GetBillingTypeResponse,
  SetBillingTypeRequestBody,
  DownloadBillListReqBody,
  DownloadBillListResponse,
} from "../../models/bills/bills.model";
import { GetGraphDataRequestBody } from "../../models/consumptions/consumptions.model";
import { downloadBillsDocument } from "../../../utils/components/bills/bills.util";
import { API_ENDPOINTS } from "../../../config/endpoints.config";
interface CustomWindow extends Window {
  PreviewAnyFile?: {
    previewBase64: (
      successCallback: (win: any) => void,
      errorCallback: (error: any) => void,
      base64String: string,
    ) => void;
  };
}

declare let window: CustomWindow;

const getBills = async (
  requestBody: GetBillsRequestBody,
  token: string,
  abortSignal: AbortSignal,
): Promise<GetBillsRequestResponse> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_BILL, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getBillsIdDocumentsList = async (
  requestBody: GetBillsRequestBody,
  token: string,
  abortSignal: AbortSignal,
): Promise<GetBillsIdDocumentsListRequestResponse> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_BILL_ID_LIST, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const downloadBill = async (billId: string, token: string): Promise<void> => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  const { bill: billByte }: DownloadBillResponse = await axios
    .post(API_ENDPOINTS.CLIENT_BILL_DOWNLOAD(billId), null, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

  try {
    if (isMobile && typeof cordova !== "undefined") {
      window.PreviewAnyFile?.previewBase64(
        (win: any) => console.log("open status", win),
        (error: any) => console.error("open failed", error),
        `data:application/pdf;base64,${billByte}`,
      );
    } else {
      const url = `data:application/pdf;base64,${billByte}`;
      const link = document.createElement("a");
      if (link.download !== undefined) {
        downloadBillsDocument(url, link, `Factura-${billId}.pdf`);
      }
    }
  } catch (error) {
    throw error;
  }
};

const downloadBillsList = async (
  requestBody: DownloadBillListReqBody,
  token: string,
  abortSignal: AbortSignal,
): Promise<DownloadBillListResponse> =>
  await axios
    .post(API_ENDPOINTS.DOWNLOADS_SEND_MESSAGE, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getGraphDataBills = (
  getGraphDataRequestBody: GetGraphDataRequestBody,
  token: string,
): Promise<GetGraphDataBillsResponse> =>
  axios
    .post(API_ENDPOINTS.CLIENT_SUMMARY_BILL, getGraphDataRequestBody, {
      headers: {
        Authorization: token,
      },
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const getBillingType = async (
  requestBody: GetBillingTypeRequestBody,
  token: string,
  abortSignal: AbortSignal,
): Promise<GetBillingTypeResponse> =>
  await axios
    .post(API_ENDPOINTS.CLIENT_CUPS_GETCOMMUNICATION, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    })
    .then(({ data }) => data)
    .catch((error) => {
      throw error;
    });

const setBillingType = async (
  requestBody: SetBillingTypeRequestBody,
  token: string,
  abortSignal: AbortSignal,
): Promise<void> => {
  try {
    await axios.post(API_ENDPOINTS.CLIENT_CUPS_SETCOMMUNICATION, requestBody, {
      headers: {
        Authorization: token,
      },
      signal: abortSignal,
    });
  } catch (error) {
    throw error;
  }
};

export {
  getBills,
  downloadBill,
  getGraphDataBills,
  getBillsIdDocumentsList,
  downloadBillsList,
  getBillingType,
  setBillingType,
};
